import * as Yup from "yup";

export const TotalCostValidation = (
  formatWithCurrency: (value: number) => string,
) =>
  Yup.number()
    .required('"Total cost (inc. setup fee) + approved amount" is required')
    .positive("Should be a positive number")
    .min(
      1000,
      (s) => `Total cost can't be lower than ${formatWithCurrency(s.min)}`,
    )
    .max(
      1000 * 1000 * 1000,
      (schema) =>
        `"Total cost (inc. setup fee) + approved amount" can't be greater than ${formatWithCurrency(schema.max)}`,
    )
    .when(["amount", "setupFee"], ([amount, setupFee], schema) => {
      if (amount && setupFee) {
        return schema.moreThan(
          (amount as number) + (setupFee as number) - 1,
          "Setup fee should be included in calculation of total cost. Currently total cost is smaller than amount + setup fee.",
        );
      }
      if (amount) {
        return schema.min(
          amount,
          (s) =>
            `"Total cost (inc. setup fee) + approved amount" can't be lower than approved amount (${formatWithCurrency(s.min)})`,
        );
      }

      return schema;
    });
